import * as React from 'react';
import { Form } from '../../types/form';
import { Breakpoint } from '@mui/material';

export enum FormOperation {
  CREATE,
  UPDATE,
}

export function useFormDialog<Item extends { id: string; date?: string }>({
  form,
  onChange,
  onSave,
}: {
  form: Form<Item>;
  onChange: (item: Item) => void;
  onSave?: (item: Item) => void;
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [item, setItem] = React.useState<Item>();
  const [formOperation, setFormOperation] = React.useState<FormOperation>();

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
    setFormOperation(undefined);
    setItem(undefined);
  }, []);

  const openDialog = React.useCallback(
    (item: Item, formOperation: FormOperation) => {
      setItem(item);
      setFormOperation(formOperation);
      setIsOpen(true);
    },
    [setItem, setFormOperation]
  );

  const dialogProps = React.useMemo(() => {
    if (!item || formOperation === undefined) {
      return null;
    }

    return {
      formOperation,
      isOpen,
      maxWidth: 'md' as Breakpoint,
      onClose: handleClose,
      form,
      item,
      saveClient: onSave,
      handleChange: onChange,
    };
  }, [item, isOpen, formOperation, handleClose, form, onSave, onChange]);

  return {
    openDialog,
    dialogProps,
  };
}
